var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlashcard = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.15 4.387c-2.08.536-3.687 1.167-5.765 2.272a1.388 1.388 0 0 0-.699 1.534c.814 3.595 1.657 5.9 3.367 9.165a1.39 1.39 0 0 0 1.518.717c3.016-.642 4.892-1.375 7.765-2.988a.274.274 0 0 0 .133-.299",
  stroke: "#3A434A",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.476 3.056c.135-.612.661-1.06 1.286-1.09 2.79-.135 4.696.05 7.415.658.624.14 1.071.688 1.088 1.326.095 3.685-.119 6.107-.857 9.678a1.39 1.39 0 0 1-1.283 1.11c-2.799.151-4.709-.02-7.441-.661a1.39 1.39 0 0 1-1.068-1.296c-.155-3.682.065-6.126.86-9.725Z",
  stroke: "#3A434A",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})));
export default SvgFlashcard;